import { render, staticRenderFns } from "./Dialog_GetClassHourDetail.vue?vue&type=template&id=088e2af9&scoped=true&"
import script from "./Dialog_GetClassHourDetail.vue?vue&type=script&lang=js&"
export * from "./Dialog_GetClassHourDetail.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_GetClassHourDetail.vue?vue&type=style&index=0&id=088e2af9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e2af9",
  null
  
)

export default component.exports